import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthContext } from '@/context/AuthContext.tsx';
import Middleware from '@/router/middleware/index.tsx';
import Routes from '@/router/Routes.ts';
import useCurrentUser from '@/api/useCurrentUser.ts';

const IsAdmin: FC = () => {
  const { isLoading, session } = useAuthContext();
  const { data: currentUser, isLoading: isLoadingUser } = useCurrentUser();

  const isAllowed = !!session && currentUser?.user_type === 'admin';

  return (
    <Middleware isLoading={isLoading || (session ? isLoadingUser : false)}>
      {isAllowed ? <Outlet /> : <Navigate to={Routes.DASHBOARD} />}
    </Middleware>
  );
};

export default IsAdmin;


